import { QLookup } from '@qualio/ui-components';
import { Group, User } from '../../types';
import { QLookUpUserWrapperGroupsCell } from './QLookUpUserWrapperGroupsCell';
import i18n from '../../i18n/config';

export const getUserLookupView = (groups: Group[]): QLookup.DataView<User> => ({
  full_name: {
    header: i18n.t('common.labels.fullName'),
    width: 'auto',
  },
  email: {
    header: i18n.t('common.labels.email'),
    width: 'auto',
  },
  groups: {
    header: i18n.t('common.labels.groups'),
    width: 'auto',
    render: (groupsFromUser: User['groups'], original: User) => {
      if (!original || !groupsFromUser) {
        return null;
      }
      return (
        <QLookUpUserWrapperGroupsCell groupIds={groupsFromUser!} availableGroups={groups} identifier={original.id} />
      );
    },
  },
});
